export function isSpooky() {
    const today = new Date();
    // Last 7 days of October (25-31); months are 0-indexed
    return today.getMonth() === 9 && today.getDate() >= 25;
}
